import { useQuery, gql } from '@apollo/client';
import { useSelector } from 'react-redux';

export function useHistoricLog() {
  const {
    waterQuality: {
      filterPressure: {
        graphicLog: { year, week, day, dataPoint },
      },
    },
  } = useSelector(({ state }) => state);
  const { data = { HistoricPressureLog: [] }, loading } = useQuery(GET_OVERVIEW, {
    variables: { year, week, day },
    skip: skip({ year, week, day }),
  });
  let dataOverview = [];
  data.HistoricPressureLog.forEach((rows) => {
    if (rows.data_point !== dataPoint) return;
    dataOverview.push(rows);
  });
  return { loading, data: dataOverview || [] };
}

function skip(variables) {
  let skip = true;
  let { year, week, day } = variables;
  skip = ![year && week && day].every((v) => v);
  return skip;
}

const GET_OVERVIEW = gql`
  query ReportResponsePressureLog($year: Int!, $week: Int!, $day: Int!) {
    HistoricPressureLog: ReportResponsePressureLog(year: $year, week: $week, day: $day) {
      _id
      text
      data_point
      color
      data {
        _id
        hour
        value
      }
    }
  }
`;
